import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "content" }

import { computed, ref, onMounted, onUnmounted } from "vue";
import { useI18n } from "vue-i18n";

import { scrollToHome } from "@/common/utils/common";
import { toast } from "@/common/utils/toast";

import { analysisShow } from "@/common/api/rest/analysis/analysis";

import type { AnalysisType, AnalysisListType } from "@/common/types/analysis";
import type { CompanyType } from "@/common/types/company";

import { baseAccordion, svgIcon } from "@/common/components";
import {
  analysisAnalyse,
  analysisSignature,
  analysisTabEquipment,
  analysisTabEmployee,
  analysisTabForm,
  analysisTabMethod,
  analysisTabResult,
  analysisTabSample,
  analysisTabQuestions,
  analysisTabReport,
} from "@/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'home',
  props: {
    data: {},
    company: {},
    evaluationCode: {},
    addressId: {},
    width: { default: "100%" },
    isEdit: { type: Boolean, default: true }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const analysis = ref<AnalysisType | null>(null);

const accordionsOpen = ref<boolean[]>([true]);

const accordions = computed(() => {
  const list = [
    {
      key: "analyse",
      title: t("common.labels.analyse").toUpperCase(),
      icon: "settings",
      component: analysisAnalyse,
      props: {
        data: analysis.value,
      },
    },
    {
      key: "questions",
      title: t("common.labels.questions").toUpperCase(),
      icon: "form",
      component: analysisTabQuestions,
      props: {
        data: analysis.value,
      },
    },
    {
      key: "form",
      title: t("common.labels.form").toUpperCase(),
      icon: "document",
      component: analysisTabForm,
      props: {
        data: analysis.value,
      },
    },
    {
      key: "method",
      title: t("common.labels.method").toUpperCase(),
      icon: "method",
      component: analysisTabMethod,
      props: {
        data: analysis.value,
      },
    },
    {
      key: "employee",
      title: t("common.labels.employee").toUpperCase(),
      icon: "card",
      component: analysisTabEmployee,
      props: {
        company: props.company,
        data: analysis.value,
      },
    },
    {
      key: "equipment",
      title: t("common.labels.equipment").toUpperCase(),
      icon: "equipment",
      component: analysisTabEquipment,
      props: {
        data: analysis.value,
      },
    },
    {
      key: "sample",
      title: t("common.labels.sample").toUpperCase(),
      icon: "samples",
      component: analysisTabSample,
      props: {
        data: analysis.value,
      },
    },
    {
      key: "result",
      title: t("common.labels.results").toUpperCase(),
      icon: "document",
      component: analysisTabResult,
      props: {
        data: analysis.value,
      },
    },
    {
      key: "signature",
      title: t("common.labels.subscriptions").toUpperCase(),
      icon: "signature",
      component: analysisSignature,
      props: {
        data: analysis.value,
        accountId: analysis.value?.account_id,
        analysisId: analysis.value?.analysis_id,
      },
    },
    {
      key: "report",
      title: t("report.titles.field_memory").toUpperCase(),
      icon: "reports",
      component: analysisTabReport,
      props: {
        analysisId: analysis.value?.analysis_id,
      },
    },
  ];

  if (!props.isEdit) {
    return list
      .map((item) => {
        if (item.key === "method")
          return {
            ...item,
            props: {
              ...item.props,
              isEdit: false,
            },
          };

        return item;
      })
      .filter((item) => item.key !== "form" && item.key !== "result");
  }

  return list;
});

function fetchData() {
  if (!props.data) return;

  analysisShow(props.data.account_id, props.data.analysis_id)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        analysis.value = data;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function toggleAccordion(index: number) {
  accordions.value.forEach((_, idx) => {
    accordionsOpen.value[idx] = index === idx;
  });

  scrollToHome(accordions.value[index].key);
  fetchData();
}

function update() {
  emit("update-data");
  fetchData();
}

onUnmounted(() => {
  const content = document.getElementsByClassName(
    "evaluation-content",
  )[0] as any;

  if (content) {
    content.style.paddingBlock = "1rem";
    content.style.paddingInline = "1.5rem";
  }
});

onMounted(() => {
  fetchData();

  const content = document.getElementsByClassName(
    "evaluation-content",
  )[0] as any;

  if (content) {
    content.style.paddingBlock = 0;
    content.style.paddingInline = 0;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["tab-component", { width: __props.width }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accordions.value, (item, index) => {
        return (_openBlock(), _createBlock(_unref(baseAccordion), {
          key: index,
          id: item.key,
          open: accordionsOpen.value[index],
          "header-padding-block": "0.75rem",
          "header-padding-inline": "1.5rem",
          "padding-block": "0",
          "padding-inline": "0",
          onOpen: ($event: any) => (toggleAccordion(index))
        }, {
          title: _withCtx(() => [
            _createVNode(_unref(svgIcon), {
              icon: item.icon,
              size: "1.75rem"
            }, null, 8, ["icon"]),
            _createTextVNode(" " + _toDisplayString(item.title), 1)
          ]),
          content: _withCtx(() => [
            (item.component)
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(item.component), _mergeProps({
                  key: 0,
                  ref_for: true
                }, item.props, {
                  onUpdateData: _cache[0] || (_cache[0] = ($event: any) => (update()))
                }), null, 16))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["id", "open", "onOpen"]))
      }), 128))
    ])
  ], 2))
}
}

})